import { render, staticRenderFns } from "./LocationDataTable.vue?vue&type=template&id=37a9d444"
import script from "./LocationDataTable.vue?vue&type=script&lang=js"
export * from "./LocationDataTable.vue?vue&type=script&lang=js"
import style0 from "./LocationDataTable.vue?vue&type=style&index=0&id=37a9d444&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports